import styled from "styled-components";

export const RolesPageContainer = styled.div`
  padding-inline: 28px;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 200px;
`;
